import { render, staticRenderFns } from "./GED.vue?vue&type=template&id=7640f1ba&scoped=true&"
import script from "./GED.vue?vue&type=script&lang=ts&"
export * from "./GED.vue?vue&type=script&lang=ts&"
import style0 from "./GED.vue?vue&type=style&index=0&id=7640f1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7640f1ba",
  null
  
)

export default component.exports